import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SidebarService } from '../../core/services/sidebar.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnDestroy {
  sidebarOpen = false;
  sidebarCollapsed = false;
  private destroy$ = new Subject<void>();

  constructor(private sidebarService: SidebarService) {}

  ngOnInit(): void {
    this.sidebarService.open$.pipe(takeUntil(this.destroy$)).subscribe((open) => {
      this.sidebarOpen = open;
    });

    this.sidebarService.collapsed$.pipe(takeUntil(this.destroy$)).subscribe((c) => {
      this.sidebarCollapsed = c;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  closeOverlay(): void {
    this.sidebarService.close();
  }
}
